import { render, staticRenderFns } from "./PdfDisclaimer.vue?vue&type=template&id=7381e576&scoped=true"
import script from "./PdfDisclaimer.vue?vue&type=script&lang=js"
export * from "./PdfDisclaimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7381e576",
  null
  
)

export default component.exports